/**
 * 사용자레벨 구분 코드
 * https://www.notion.so/barogohq/9ab774a7671245ebbae0579e4e1997dd
 *
 * 추후 상담원/가맹점은 사라질 예정
 * https://barogo.slack.com/archives/C04UP4VFCKA/p1698740491371879
 */
import { i18n } from '@/locales';
const lc = 'views.user_level.';
// 사용자 레벨 1차 분류
// 10 상담원
// 20 상점
// 30 허브
// 40 총판
// 70 본사
// 사용자 레벨 2차 분류
// x0 사용자
// x1 관리자
// x2 마스터
export const userLevelCode = {
    // 상담원
    10: {
        text: i18n.t(`${lc}store_consultant`),
        code: 'STORE_CONSULTANT',
        value: '10',
    },
    // 가맹점사용자 = 상점사용자
    20: {
        text: i18n.t(`${lc}store_user`),
        code: 'STORE_USER',
        value: '20',
    },
    // 가맹점관리자 = 상점관리자
    21: {
        text: i18n.t(`${lc}store_admin`),
        code: 'STORE_ADMIN',
        value: '21',
    },
    // 가맹점MASTER = 상점MASTER
    22: {
        text: i18n.t(`${lc}store_master`),
        code: 'STORE_MASTER',
        value: '22',
    },
    // 지사사용자 = 허브사용자
    30: {
        text: i18n.t(`${lc}hub_user`),
        code: 'HUB_USER',
        value: '30',
    },
    // 지사관리자 = 허브관리자
    31: {
        text: i18n.t(`${lc}hub_admin`),
        code: 'HUB_ADMIN',
        value: '31',
    },
    // 지사MASTER = 허브MASTER
    32: {
        text: i18n.t(`${lc}hub_master`),
        code: 'HUB_MASTER',
        value: '32',
    },
    // 총판사용자
    40: {
        text: i18n.t(`${lc}dist_user`),
        code: 'DIST_USER',
        value: '40',
    },
    // 총판관리자
    41: {
        text: i18n.t(`${lc}dist_admin`),
        code: 'DIST_ADMIN',
        value: '41',
    },
    // 총판MASTER
    42: {
        text: i18n.t(`${lc}dist_master`),
        code: 'DIST_MASTER',
        value: '42',
    },
    // 본사 유저
    70: {
        text: i18n.t(`${lc}system_user`),
        code: 'SYSTEM_USER',
        value: '70',
    },
    // 본사 관리자
    71: {
        text: i18n.t(`${lc}system_admin`),
        code: 'SYSTEM_ADMIN',
        value: '71',
    },
    // 본사 관리자
    72: {
        text: i18n.t(`${lc}system_master`),
        code: 'SYSTEM_MASTER',
        value: '72',
    },
};
export const userLevel = {
    HUB: 'HUB',
    DISTRIBUTOR: 'DISTRIBUTOR',
};
export const userLevelKr = {
    HUB: i18n.t(`${lc}hub`),
    DISTRIBUTOR: i18n.t(`${lc}dist`),
};
